export type QueryParams = Record<string, string | number | undefined | null>;

export default function prepareQueryParams(queryParams?: QueryParams) {
  if (!queryParams) {
    return '';
  }

  const queryParamsString = Object.keys(queryParams)
    .sort()
    .map((key) => `${key}=${queryParams[key]}`)
    .join('&')
    .replaceAll('undefined', '');

  if (queryParamsString === '') {
    return '';
  }

  return '?' + queryParamsString;
}
